import React, { useCallback, useContext, useRef, useState } from 'react'
import {
  dateTimeCol,
  intCol,
  numCol,
  strCol,
} from '@integec/grid-tools/lib/cols'
import {
  ExportComponent,
  exportDataComponent,
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
  getValidYearRange,
} from 'core'
import UtilityUnitSelection from 'core/component/UtilityUnitSelection'
import { connect } from 'react-redux'
import { Button, DatePicker, Divider, Input, message } from 'antd'
import {
  DatePickerContext,
  // UnitSelectionContext,
  SpinContext,
  ErrorContext,
  UnitSelectionContext,
} from 'context'
import {
  Content,
  CriteriaRow,
  FullHeightSizer,
  Title,
} from '../core/screen-util'
import {
  downloadOutageAnalyzerReport,
  getOutageAnalyzerData,
} from '../api/pgads'
import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'
import JcTmpErrorContext from '../context/JcTmpErrorContext'
import { isErrorContains } from '../core/component/JcTmpErrorDialog'
import { downloadFile } from 'reports/dm/reportCall'
import { isValidYearRange, rowHeaderRender } from 'core/utils'
const OutageAnalyzer = ({ targetInfo, ...props }) => {
  const GridRef = useRef()

  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )
  const { setError } = useContext(ErrorContext)
  const { setSpinning } = useContext(SpinContext)
  const { selectedUnits } = useContext(UnitSelectionContext)
  const { setTmpError } = useContext(JcTmpErrorContext)
  const [utility, setUtility] = useState((selectedUnits[0] || {}).utility)
  const [unit, setUnit] = useState((selectedUnits[0] || {}).unitId)
  const [fuzzyFilter, setFuzzyFilter] = useState('')
  // const [utility, setUtility] = useState()
  // const [unit, setUnit] = useState()

  const [data, setData] = useState({})

  const retrieveData = _ => {
    if (!unit) {
      message.info('Please, Select Unit')
      return
    }
    const isValid = isValidYearRange(
      props.validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
    if (!isValid) return

    const req = {
      startdate: selectedDateRangePicker[0].format('YYYY-MM-DD'),
      enddate: selectedDateRangePicker[1].format('YYYY-MM-DD'),
      unitid: unit,
    }
    setSpinning(true)
    getOutageAnalyzerData(targetInfo)(req).fork(setError, res => {
      setSpinning(false)

      const error = res.tmpError
      if (error.length > 0) setTmpError(error)
      if (isErrorContains(error)) {
        setData(res) // need to blank data
      } else {
        setData(res)
      }
    })
  }

  // reportType= view=RPT_OUTPUT_PDF downlaod  = RPT_OUTPUT_CSV
  const downloadReport = ({
    reportType = 'RPT_OUTPUT_PDF',
    reportId = '2',
  }) => {
    const isValid = isValidYearRange(
      props.validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
    if (!isValid) return

    const req = {
      startdate: selectedDateRangePicker[0].format('YYYY-MM-DD'),
      enddate: selectedDateRangePicker[1].format('YYYY-MM-DD'),
      unitid: unit,
      reportType,
      reportId,
    }
    setSpinning(true)
    downloadOutageAnalyzerReport(targetInfo)(req).fork(setError, res => {
      setSpinning(false)

      // const v =
      downloadFile(targetInfo)(res.fname)
    })
  }

  const title = 'Outage Analyzer'

  const changeDates = dates => {
    setSelectedDateRagePicker([
      dates[0].startOf('month'),
      dates[1].endOf('month'),
    ])
  }

  const OaPjmCard97IoHeadersFunc = useCallback(width => {
    const headers = [
      // strCol({ ident: 'author', display: 'Author', isKey: true }),
      // strCol({ ident: 'bookName', display: 'BookName', isKey: true }),
      // strCol({ ident: 'caseName', display: 'CaseName', isKey: true }),
      // strCol({ ident: 'unitname', display: 'Unitname', isFiltered: true }),
      // strCol({ ident: 'utility', display: 'Utility', isFiltered: true }),
      // strCol({ ident: 'unit', display: 'Unit', isFiltered: true }),
      intCol({ ident: 'year', display: 'Year', isFiltered: true }),
      // strCol({ ident: 'included', display: 'Included', isFiltered: true }),
      intCol({ ident: 'eventnum', display: 'Event Number', isFiltered: true }),
      strCol({ ident: 'eventtype', display: 'Event Type', isFiltered: true }),
      // strCol({ ident: 'eventtypeMod', display: 'EventtypeMod', isFiltered: true }),
      dateTimeCol({
        ident: 'eventstart',
        display: 'Event Start',
        isFiltered: true,
        width: 150,
      }),
      // dateTimeCol({
      //   ident: 'eventstartGmt',
      //   display: 'Event start Gmt',
      //   isFiltered: true,
      //   width: 200,
      // }),
      // strCol({
      //   ident: 'eventstartMod',
      //   display: 'EventstartMod',
      //   isFiltered: true,
      // }),
      dateTimeCol({
        ident: 'eventend',
        display: 'Event End',
        isFiltered: true,
        width: 150,
      }),
      // dateTimeCol({
      //   ident: 'eventendGmt',
      //   display: 'EventendGmt',
      //   isFiltered: true,
      // }),
      // strCol({ ident: 'eventendMod', display: 'EventendMod', isFiltered: true }),
      numCol({
        ident: 'availcap',
        display: 'Availiable Capacity',
        isFiltered: true,
      }),
      // strCol({ ident: 'availcapMod', display: 'AvailcapMod', isFiltered: true }),
      numCol({ ident: 'foh', display: 'FOH', isFiltered: true }),
      numCol({ ident: 'efdh', display: 'EFDH', isFiltered: true }),
      numCol({ ident: 'efdhrs', display: 'EFDH During RS', isFiltered: true }),
      // numCol({ ident: 'servSyncPump', display: 'ServSyncPump', isFiltered: true }),
      // numCol({ ident: 'pctInMoney', display: 'PctInMoney', isFiltered: true }),
      // numCol({ ident: 'pctOutMoney', display: 'PctOutMoney', isFiltered: true }),
      intCol({ ident: 'causecode', display: 'Cause Code', isFiltered: true }),
      // strCol({ ident: 'causecodeMod', display: 'CausecodeMod', isFiltered: true }),
      strCol({
        ident: 'causeDescrip',
        display: 'Cause Code Description',
        isFiltered: true,
        width: 300,
        alignment: 'left',
        ellipsis: true,
      }),
      // strCol({
      //   ident: 'description',
      //   display: 'Description',
      //   isFiltered: true,
      //   width: 300,
      //   alignment: 'left',
      //   ellipsis: true,
      // }),
      // numCol({ ident: 'netdepcap', display: 'Netdepcap', isFiltered: true }),
      // strCol({ ident: 'recordid', display: 'Recordid', isFiltered: true }),
      // strCol({ ident: 'action', display: 'Action', isFiltered: true }),
    ]

    const wd =
      width - headers.map(d => d.width || 100).reduce((a, b) => a + b) - 20
    return [
      ...headers,
      strCol({
        ident: 'description',
        display: 'Description',
        isFiltered: true,
        width: wd < 100 ? 100 : wd,
        alignment: 'left',
        ellipsis: true,
      }),
    ]
  }, [])

  return (
    <div>
      <CriteriaRow>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '100px 3fr 2fr',
            gap: '5px',
            width: '100%',
          }}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr',
              paddin: '1%',
            }}
          >
            <Title>Outage</Title>
            <Title>Analyzer</Title>
          </div>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr',
              gap: '5px',
            }}
          >
            <DatePicker.RangePicker
              style={{ width: '100%' }}
              allowClear={false}
              mode={['month', 'month']}
              format="MMM-YYYY"
              value={selectedDateRangePicker}
              onChange={changeDates}
              onCalendarChange={changeDates}
              onOk={changeDates}
              onPanelChange={changeDates}
              showTime={false}
            />
            <div style={{ gridColumnEnd: 'span 2' }}>
              <UtilityUnitSelection
                defaultValue={[utility, unit]}
                utility={utility}
                unit={unit}
                onUnitChange={value => {
                  setUtility(value[0])
                  setUnit(value[1])
                }}
                casStyle={{ width: '100%' }}
              />
            </div>
            <Button onClick={retrieveData} type="primary" icon="database">
              Retrieve
            </Button>
            <Input.Search
              placeholder="Filter"
              value={fuzzyFilter}
              style={
                {
                  // marginLeft: '10px',
                  // marginRight: '10px',
                  // flex: '0 0 200px',
                  // width: '90%',
                }
              }
              onChange={e => setFuzzyFilter(e.target.value)}
            />
            <ExportComponent
              getData={_ =>
                exportDataComponent(GridRef, data.card97 || [], fuzzyFilter)
              }
              data={data.card97}
              headers={(OaPjmCard97IoHeadersFunc(1000) || []).map(d => ({
                ...d,
                rowHeaderBackgroundColor: '#eee',
              }))}
              fileName={title}
              btnStyle={{}}
              disabled={(data.card97 || []).length <= 0}
            />
          </div>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              // padding: '5px',
              gap: '5px',
            }}
          >
            <Button
              onClick={_ =>
                downloadReport({ reportType: 'RPT_OUTPUT_PDF', reportId: '2' })
              }
            >
              View Hourly Report
            </Button>
            <Button
              onClick={_ =>
                downloadReport({ reportType: 'RPT_OUTPUT_CSV', reportId: '2' })
              }
            >
              Download Hourly Report
            </Button>

            <Button
              onClick={_ =>
                downloadReport({ reportType: 'RPT_OUTPUT_PDF', reportId: '1' })
              }
            >
              View Constraints Report
            </Button>
            <Button
              onClick={_ =>
                downloadReport({ reportType: 'RPT_OUTPUT_CSV', reportId: '1' })
              }
            >
              Download Constraints Report
            </Button>
          </div>
        </div>
      </CriteriaRow>
      <Content>
        <div>
          <FullHeightSizer heightOffset={400}>
            {({ height, width }) => (
              <Grid
                ref={GridRef}
                data={data.card97 || []}
                headers={OaPjmCard97IoHeadersFunc(width - 50)}
                altBy={d => d.utility + d.unit}
                altBgColor="#ebebeb"
                render={virtualizedGridRenderer({
                  height: height - 40,
                  width: width - 50,
                  headerRowHeight: 60,
                  rowHeaderRender,
                })}
                fuzzyFilter={fuzzyFilter}
                initialSortOptions={OaPjmCard97IoHeadersFunc(width - 50)}
                sortOptions={OaPjmCard97IoHeadersFunc(width - 50)}
                sortEnabled={false}
                isEditable={false}
                selectionType="row"
                selectionMode="single"
              />
            )}
          </FullHeightSizer>
          <Divider style={{ margin: '10px 0px' }} />
          <div style={{ minHeight: '200px' }}>
            <Grid
              data={data.totals || []}
              headers={OaPjmTmpTotalsHeaders}
              render={virtualizedGridRenderer({
                rowHeaderRender,
                height: 200,
                // width: width - 100,
                headerRowHeight: 30,
              })}
              fuzzyFilter={fuzzyFilter}
              sortEnabled={false}
              isEditable={false}
              selectionType="row"
              selectionMode="single"
            />
          </div>
        </div>
      </Content>
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
  validYearRange: getValidYearRange(state),
})

export default connect(mapStateToProps)(OutageAnalyzer)

const OaPjmTmpTotalsHeaders = [
  //  strCol({ ident: 'bookName', display: 'BookName', isFiltered: true }),
  //  strCol({ ident: 'caseName', display: 'CaseName', isFiltered: true }),
  numCol({
    ident: 'foh',
    display: 'Peak FOH (Forced Outage Hrs)',
    isFiltered: true,
    width: 250,
  }),
  numCol({
    ident: 'efdh',
    display: 'Peak EFDH (Equiv Forced Derate Hrs)',
    isFiltered: true,
    width: 250,
  }),
  numCol({
    ident: 'efdhrs',
    display: 'Peak EFDHRS (EFDH During Reserve)',
    isFiltered: true,
    width: 250,
  }),
  numCol({
    ident: 'servSyncPump',
    display: 'Service/Synch/Pump Hrs',
    isFiltered: true,
    width: 250,
  }),
  numCol({ ident: 'eforp', display: 'EFORp', isFiltered: true }),
]
